import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import EmptyGraphic from '../EmptyGraphic';
import StatisticBlock from '../StatisticBlock';
import StatisticButton from '../StatisticButton';
// import StatisticText from '../StatisticText';
import s from './EmptyState.scss';

interface Props {}

/** The empty state for a subscription stats panel with no data */
const EmptyState: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <div className={s['top-row']}>
        <StatisticBlock
          heading="Total Income"
          alignment="left"
          statistic={null}
          postfix={
            <StatisticButton
              biData={{
                evid: BiEventType.DEFAULT,
                click_info: 'tier_manage_earnings',
              }}
              onClick={() => window.location.assign(URLS.EARNINGS)}
            >
              {t('widgets.subscriptionsSection.manageEarnings.button.text')}
            </StatisticButton>
          }
        />

        <StatisticBlock
          heading="Total Subscribers"
          alignment="right"
          statistic={null}
          postfix={
            <StatisticButton
              biData={{
                evid: BiEventType.DEFAULT,
                click_info: 'tier_manage_customers',
              }}
              onClick={() => window.location.assign(URLS.CUSTOMER_DASHBOARD)}
            >
              {t('widgets.subscriptionsSection.manageSubscribers.button.text')}
            </StatisticButton>
          }
        />
      </div>
      <EmptyGraphic />
    </div>
  );
};
EmptyState.displayName = 'EmptyState';

export default EmptyState;
